// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"223":"commons","245":"component---src-pages-index-tsx","453":"component---src-pages-404-tsx"}[chunkId] || chunkId) + "-" + {"223":"3c4ed04985dcf7c4ed51","245":"5342d056c433b2508a5a","453":"af4722003af80ab63f33","454":"3b8abc0699206e70852e","607":"fe95f0babddd6058d08c"}[chunkId] + ".js";
};